

export function arrayForSelect(arr, keyName, valueKey) {
    return arr?.map(item => ({
        label: item[keyName],
        value: item[valueKey]
    }));
}
